import { type ReactNode } from 'react'
import { isDefined, type CardThemeTokens, type Review } from '@terros/common'
import { Group, Stack, Text } from '@mantine/core'
import { Theme, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

const STARS = [1, 2, 3, 4, 5]

type Props = {
  review: Review | undefined
  tokens: CardThemeTokens
}

export const PreviewReview = ({ review, tokens }: Props): ReactNode => {
  const { t } = useTranslation()
  const rating = review?.rating ?? 5
  const reviewText = isDefined(review)
    ? t('“{{text}}”', { text: review.text })
    : t('“A great experience from start to finish.”')
  const authorName = review?.author.name ?? t('Sample customer')

  return (
    <Stack gap='xs'>
      <Group gap={0}>
        {STARS.map((star) => (
          <MaterialSymbolIcon
            key={star}
            color={star <= rating ? tokens.accentOnLight : Theme.light.icon.neutral.tertiary}
            filled={star <= rating}
            icon='star'
            size='md'
          />
        ))}
      </Group>
      <Text c={Theme.light.text.neutral.secondary} size='sm'>
        {reviewText}
      </Text>
      <Text c={tokens.ink} className='font-semibold'>
        {authorName}
      </Text>
    </Stack>
  )
}
